import { useState, useEffect } from 'react'
import { useDesktopStore } from '../../stores/desktopStore'
import { useWindowStore } from '../../stores/windowStore'
import './Taskbar.css'

export function Taskbar() {
  const [time, setTime] = useState(new Date())
  const toggleStartMenu = useDesktopStore((state) => state.toggleStartMenu)
  const startMenuOpen = useDesktopStore((state) => state.startMenuOpen)
  const windows = useWindowStore((state) => state.windows)
  const activeWindowId = useWindowStore((state) => state.activeWindowId)
  const restoreWindow = useWindowStore((state) => state.restoreWindow)
  const minimizeWindow = useWindowStore((state) => state.minimizeWindow)

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }

  const handleTaskbarItemClick = (windowId: string, state: string) => {
    if (state === 'minimized') {
      restoreWindow(windowId)
    } else if (windowId === activeWindowId) {
      minimizeWindow(windowId)
    } else {
      restoreWindow(windowId)
    }
  }

  return (
    <div className="taskbar" role="navigation" aria-label="Taskbar">
      {/* Start Button */}
      <button
        className={`taskbar__start ${startMenuOpen ? 'active' : ''}`}
        onClick={toggleStartMenu}
        aria-expanded={startMenuOpen}
        aria-haspopup="menu"
      >
        <span className="taskbar__start-icon">■</span>
        <span className="taskbar__start-text">Start</span>
      </button>

      {/* Window List */}
      <div className="taskbar__windows">
        {windows.map((window) => (
          <button
            key={window.id}
            className={`taskbar__item ${
              window.id === activeWindowId && window.state !== 'minimized'
                ? 'active'
                : ''
            } ${window.state === 'minimized' ? 'minimized' : ''}`}
            onClick={() => handleTaskbarItemClick(window.id, window.state)}
            aria-label={window.title}
          >
            <span className="taskbar__item-title">{window.title}</span>
          </button>
        ))}
      </div>

      {/* System Tray */}
      <div className="taskbar__tray">
        <span className="taskbar__time" aria-label={`Current time: ${formatTime(time)}`}>
          {formatTime(time)}
        </span>
      </div>
    </div>
  )
}
